/**
 * @file 向后台发请求
 */

import axios, { AxiosRequestConfig } from 'axios';
import axiosRetry from 'axios-retry';

// 重新请求
axiosRetry(axios, {
  retries: 3,
  retryCondition: () => true,
});

// const defaultToken = 'UWMzRVkoaLsx0OAG';

const baseUrl = process.env.NODE_ENV === 'development' ? '' : '';

export const API = {
  location: '/cgi-bin/tools/location',
  tts: '/cgi-bin/tools/tts',
  word: '/cgi-bin/tools/word',
  ocr: '/cgi-bin/tools/ocr',
  convertGetCosCredential: '/cgi-bin/convert/getcoscredential',
  convertUpload2Cos: '/api/pdfconvert/upload2cos',
  convertStart: '/cgi-bin/convert/createtask',
  convertQuery: '/cgi-bin/convert/querytask',
  imgAi: '/cgi-bin/tools/anime_filter',
  token: '/api/getToken',
  imgTextRemove: '/cgi-bin/tools/text_removal',
  imgHumanSplit: '/cgi-bin/tools/hs',
  imgDocAi: '/cgi-bin/tools/doc_ai',
  imgFix: '/cgi-bin/tools/is',
  articleAbstract: '/cgi-bin/tools/ca',
  audioToText: '/cgi-bin/tools/rec_task',
  audioToTextRes: '/cgi-bin/tools/rec_result',
  upload: '/cgi-bin/tools/upload',
  pdfcreatetask: '/api/pdfconvert/createPdfTask',
  pdfquerytask: '/api/pdfconvert/queryPdfTask',
  pdfQueryConsumeCount: '/api/pdfconvert/queryConsumeCount',
  getLoginInfo: '/api/getLoginInfo',
  logout: '/api/logout',
  getStatistics: '/cgi-bin/tools/get_statistics',
  reportStatistics: '/cgi-bin/tools/report',
  face: '/cgi-bin/tools/face',
  foodCalories: '/cgi-bin/tools/food_calories', // 拍照查询
  calories: '/cgi-bin/tools/calories', // 文字查询
  netstatus: '/api/getNetStatus', // 网络联通性检测
  getcoscredential: '/api/getcoscredential',
  getUserInfor: '/api/getUserInfor',
  getAccessTokenV1: '/toolproxy/v1/token',
  createTaskV1: '/toolproxy/v1/create',
  queryTaskV1: '/toolproxy/v1/query',
  getBankList: '/api/getBankList', // 获取贷款银行
  getBankPolicy: '/api/getBankPolicy', // 获取贷款银行政策
  getCityRatePolicy: '/api/getCityRatePolicy', // 获取城市最低利率政策
  getLatestInterestRate: '/api/getLatestInterestRate', // 获取最新利率
};

// let getTokenPromise: Promise<string>;
// let token = '';

// setTimeout(() => {
//   getTokenPromise = http({
//     url: API.token,
//     method: 'get',
//   }).then((res) => {
//     token = res?.token || '';
//     return token;
//   });
// }, 1000);

type HttpType = (option: { url: string, method?: 'post' | 'get', param?: Record<string, any>, format?: 'json' | 'fomrdata', appendUserInfo?: boolean }) => Promise<any>;

// 不显示错误的请求
// const ingoreErrorList = [API.reportStatistics, API.getStatistics];

export const http: HttpType = async ({ url, method = 'post', format = 'json', param = {} }) => {
  console.log('🚀 ~ file: http.ts:98 ~ consthttp:HttpType= ~ format:', format);
  // const accessToken = token ? token : (await getTokenPromise);
  const config: AxiosRequestConfig = {
    method,
    url: `${baseUrl}${url}`,
    headers: {
      Timestamp: Math.floor(Date.now() / 1000),
    },
  };
  if (method === 'get') {
    config.params = {
      ...param,
    };
  }
  try {
    const rsp = await axios(config);
    if (rsp.status === 200) {
      return rsp.data;
    }
  } catch (e: any) {
    console.log('network err', e);
  }
};
